module.exports = __webpack_public_path__ + "img/hr-heat-pipe-straight-vertical-5.1daa7300.png";